import request from '@/utils/request'

export function travelmade (data) {
  return request({
    url: '/travel/made/add',
    method: 'post',
    data
  })
}
export function vcode (query) {
  return request({
    url: '/vcode/vcode',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js